import type { CSSProperties } from 'react';

export const planNameHeadingStyle: CSSProperties = {
  margin: '0 0 4px',
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0',
};

export const publishedDescriptionStyle: CSSProperties = {
  margin: '0 0 16px',
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0',
};

export const activeDescriptionStyle: CSSProperties = {
  margin: '0 0 16px',
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0',
};

export const publishedHeaderWrapStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  lineHeight: '20px',
};

export const schoolsHeaderLabelStyle: CSSProperties = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px',
  fontWeight: 600,
  color: 'rgb(51, 51, 51)',
  margin: 0,
};

export const publishedCountTextStyle: CSSProperties = {
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
  color: 'rgb(102, 102, 102)',
  fontSize: '14px',
  lineHeight: '20px',
};

export const publishedActionLinkStyle: CSSProperties = {
  border: 'none',
  background: 'none',
  color: '#2F6FED',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  padding: 0,
};

export const publishedLabelStyle: CSSProperties = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  color: 'rgb(153, 153, 153)',
  marginLeft: '12px',
};

export const noSchoolsFoundStyle: CSSProperties = {
  textAlign: 'center',
  padding: '24px 0',
  color: '#636E70',
  fontSize: '14px',
  lineHeight: '20px',
};
